// extracted by mini-css-extract-plugin
export default {"container":"zIQOQ","searchWrapper":"tq6zn","table":"HG42W","p-component":"bPKB5"};